import PropTypes from 'prop-types';
import React from 'react';
import { encode as encodeBase64 } from 'base-64';

import { noop } from 'lodash';

import { ConfigsService, LocaleService, WindowProxy, UrlService } from '@sm360/widget-commons-core-services';
import { AccountService, ModalService, REDIRECTIONS } from '@sm360/widget-commons-general';
import { LeadSubmissionBuilder, LEAD_TYPES } from '@sm360/widget-commons-leads';

import QuoteModel from 'commons-vehicle/Quote/models/QuoteModel.js';
import QuoteActions from 'commons-vehicle/Quote/actions/quoteActions.js';
import QuoteService from 'commons-vehicle/Quote/services/QuoteService/QuoteService.js';
import ShowroomService from 'commons-vehicle/services/ShowroomService/ShowroomService.js';

import 'commons-vehicle/Vehicle/components/CallToAction/BuyOnline/BuyOnlineCTA.scss';

class BuyOnlineCTA extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            iconClass: props.iconClass,
            classNames: ['btn-get-started', props.buttonClass, 'vehicle-cta-btn'],
        };

        this.buyOnline = this.buyOnline.bind(this);
        this.onBuyOnline = this.onBuyOnline.bind(this);
        this.saveQuote = this.saveQuote.bind(this);
        this.buyOnline = this.buyOnline.bind(this);

        this.onCloseCallBacks = {
            onClose: (params) => {
                const newAccount = params && params.newAccount;
                if (AccountService.isAuthenticated()) {
                    this.buyOnline(newAccount);
                }
                return true;
            },
        };
    }

    onBuyOnline() {
        this.props.onClick();
        if (ConfigsService.isInMobileApp()) {
            this.saveQuote();
        } else if (!AccountService.isAuthenticated()) {
            const LoginModal = ModalService.get('login/SignUpModal');
            LoginModal.addCallbacks(this.onCloseCallBacks);
            LoginModal.open({ submitAccountCreationLead: false });
        } else {
            this.setState({
                iconClass: 'icon-refresh',
                classNames: ['btn-get-started', this.props.buttonClass, 'vehicle-cta-btn', 'clicked'],
            });
            this.saveQuote();
        }
    }

    buyOnline() {
        if (AccountService.isAuthenticated()) {
            this.setState({
                iconClass: 'icon-refresh',
                classNames: ['btn-get-started', this.props.buttonClass, 'vehicle-cta-btn', 'clicked'],
            });
            this.saveQuote();
        }
        return true;
    }

    doCheckoutRedirect(quote) {
        const { onEndProcessGaTag } = this.props;
        const locale = LocaleService.getSimpleLocale();
        const url = REDIRECTIONS[locale].checkout;
        const windowProxy = WindowProxy.get();

        if (windowProxy) {
            const historyUrl = quote.buildUrl(windowProxy.location.href);

            windowProxy.history.replaceState({ quote }, 'tradeIn', historyUrl);

            let fullUrl = quote.buildUrl(url);
            if (onEndProcessGaTag) {
                fullUrl += `&${UrlService.encodeUriParameter(
                    'onEndProcessGaTag',
                    encodeBase64(JSON.stringify(onEndProcessGaTag))
                )}`;
            }

            if (ConfigsService.isInMobileApp() && !AccountService.isAuthenticated()) {
                windowProxy.location.href =
                    `ca.solutionsmedias360.showroom-${ConfigsService.getWebsiteId()}://` +
                    `?action=login&redirectUrl=${encodeURIComponent(fullUrl)}`;
            } else {
                windowProxy.location.href = fullUrl;
            }
        }
    }

    saveQuote(newAccount) {
        const { quote } = this.props;

        return ShowroomService.saveQuote(quote.getShowroomQuote()).then((showroomQuote) => {
            const mappedQuote = QuoteService.resetQuoteFromShowroomSave(quote, showroomQuote);

            QuoteActions.setQuote(mappedQuote);

            if (QuoteService.quoteHasVehicle(mappedQuote)) {
                const leadRequest = new LeadSubmissionBuilder({}, 'Add To Garage')
                    .addLeadType(LEAD_TYPES.ACCOUNT_CREATION)
                    .addQuote(mappedQuote)
                    .addVehicle(mappedQuote);

                if (newAccount) {
                    leadRequest.setIsAccountCreation();
                    leadRequest.addOptInEmail(newAccount.optInEmail);
                    leadRequest.addContactInformation(
                        newAccount.firstname,
                        newAccount.lastname,
                        newAccount.homePhone,
                        newAccount.email1,
                        newAccount.contactId
                    );
                }

                leadRequest.submit().then(() => {
                    this.doCheckoutRedirect(mappedQuote);
                });
            }
        });
    }

    render() {
        const { iconClass, classNames } = this.state;
        return (
            <button className={classNames.join(' ')} type="button" onClick={this.onBuyOnline}>
                {iconClass && <icon className={iconClass} />}
                <span>{this.props.alternativeLabel || LocaleService.t('CALL_TO_ACTION.BTN_BUY_ONLINE_TITLE')}</span>
            </button>
        );
    }
}

BuyOnlineCTA.defaultProps = {
    alternativeLabel: '',
    buttonClass: 'sr-button-1',
    iconClass: null,
    onClick: noop,
    onEndProcessGaTag: null,
};

BuyOnlineCTA.propTypes = {
    alternativeLabel: PropTypes.string,
    buttonClass: PropTypes.string,
    quote: PropTypes.instanceOf(QuoteModel).isRequired,
    iconClass: PropTypes.string,
    onClick: PropTypes.func,
    onEndProcessGaTag: PropTypes.shape({
        category: PropTypes.string.isRequired,
        action: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }),
};

BuyOnlineCTA.displayName = 'BuyOnlineCTA';

export default BuyOnlineCTA;
